import store from "../store";
import { liff, config } from "../main";
import { logAuthDiagnostic } from "@/utils/authDiagnostics";

// Blank Theme เด้งทุก path ไปหน้า landing ยกเว้น path ที่อนุญาตไว้
// เทียบด้วย to.path ไม่ใช่ to.fullPath เพราะ fullPath มี query string ติดมาด้วย
// ทำให้ /privilege/376?user_coupon_id=45876 ไม่เคยตรงกับ "/privilege"
const BLANK_THEME_ALLOWED_PATHS = ["/blank-theme-landing", "/privilege"];

// อนุญาตทั้ง path ตรงตัวและ sub path ของมัน เช่น /privilege/376
// ใช้ `${allowedPath}/` เพื่อไม่ให้ /privilegehistory/1 หลุดผ่านไปด้วย
function isBlankThemeAllowedPath(to) {
  const path = to?.path || "";
  return BLANK_THEME_ALLOWED_PATHS.some(
    allowedPath => path === allowedPath || path.startsWith(`${allowedPath}/`)
  );
}

function shouldRedirectToBlankThemeLanding(to) {
  return config.line_layout == "Blank Theme" && !isBlankThemeAllowedPath(to);
}

export default async function auth({ next, from, to, redirect }) {
  try {
    if (to.query.preview == "1") {
      return next();
    }

    if (!store.state.templateReady || !store.state.shortProfile.user_guid) {
      const res = await store.dispatch("getUserBind");

      if (res != 1) {
        logAuthDiagnostic("auth_guard_redirect", {
          bindResult: res,
          to: to.path,
          from: from?.path || ""
        });
      }

      if (res === -1) {
        return next({
          path: "/validatetelephone",
          query: {
            redirect: to.path,
            error: "line_profile_unavailable",
            ...to.query
          }
        });
      }

      if (res == 1) {
        if (shouldRedirectToBlankThemeLanding(to))
          return next("/blank-theme-landing");
        return next();
      } else {
        if (to.fullPath.includes("/reward")) return next();
        return next({
          path: "/validatetelephone",
          query: {
            redirect: to.path,
            ...to.query
          }
        });
      }
    } else if (shouldRedirectToBlankThemeLanding(to))
      return next("/blank-theme-landing");

    return next();
  } catch (error) {
    console.error(error);
    console.log(error);
  }
}
